import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function MainLayout() {
  return (
    <div style={{ 
      width: "100%", 
      backgroundColor: "#ffffff", // Background ko white rakhein taaki frame na dikhe
      margin: 0, 
      padding: 0 
    }}>
      <Navbar />

      <main style={{ 
        minHeight: "80vh", 
        padding: "0px", 
        margin: "0px",
        width: "100%",
        borderRadius: "0px" // Yahan confirm karein ki koi radius na ho
      }}>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}